import { Image } from 'antd'
import React, { useEffect, useState } from 'react'
import entete from "../../../assets/img/entete_pool.png"
import PropTypes from 'prop-types';
import BarreTop from '../../../components/docs/BarreTop';
import { frenchDate } from '../../../variables/functions';
import { DocumentFooter } from '../../../components/docs/DocumentFooter';
import { getCompagnieLogo } from '../../../hooks/useFilesHooks';

const NoteVictime = React.forwardRef((props, ref) => {
    const [logoPreviewUrl, setLogoPreviewUrl] = useState(null);

    useEffect(() => {
        if (props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL") {
            getCompagnieLogo(props?.sinistre?.contrat?.organisme?.code)
                .then(async (response) => {
                    const imageBytes = await response.arrayBuffer();
                    var blob = new Blob([imageBytes], { type: "image/png" });
                    var imageUrl = URL.createObjectURL(blob);
                    setLogoPreviewUrl(imageUrl);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, []);

    const today = new Date().toLocaleDateString('fr-FR', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    });

    // En-tête + pied de page OPTIONNELS : désactivés → impression « nue » sur papier à en-tête,
    // avec corps CENTRÉ verticalement. Par défaut : affichés.
    const afficherEnteteEtPied = props?.afficherEnteteEtPied !== false;

    return (
        <div ref={ref} style={{
            fontFamily: "Calibri, 'Calibri Light', sans-serif",
            maxWidth: "800px",
            margin: "0 auto",
            padding: "20px 30px",
            lineHeight: 1.5,
            fontSize: "12pt",
            color: "#000000",
            display: "flex",
            flexDirection: "column",
            minHeight: "250mm",
            boxSizing: "border-box"
        }}>

            {/* En-tête avec logos — masquable pour impression sur papier à en-tête. */}
            {afficherEnteteEtPied && (
            <div style={{ marginBottom: "20px" }}>
                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    {props?.sinistre?.contrat?.organisme?.typeOrganisme !== "POOL" && logoPreviewUrl && (
                        <img
                            src={logoPreviewUrl}
                            style={{
                                width: "auto",
                                height: "60px",
                                objectFit: "contain"
                            }}
                            alt="Logo compagnie"
                        />
                    )}
                    <img
                        src={entete}
                        style={{
                            width: "auto",
                            height: "60px",
                            objectFit: "contain"
                        }}
                        alt="En-tête"
                    />
                </div>
                <div style={{ height: "2px", background: "linear-gradient(to right, #2563eb, #3b82f6)", marginTop: "8px" }} />
            </div>
            )}

            {/* Papier à en-tête : espace flexible en haut → centre le corps verticalement. */}
            {!afficherEnteteEtPied && <div style={{ flex: 1 }} />}

            {/* Référence en haut à gauche */}
            <div style={{ marginBottom: "40px" }}>
                <p style={{ margin: 0, fontSize: "11pt", color: "#000000", fontWeight: "400" }}>
                    <span style={{ fontWeight: "700" }}>Réf:</span> {props?.sinistre?.numSinistre || '......'}/KGW/......./......./Pool TPVM-VT GIE
                </p>
            </div>

            {/* Informations de la victime à droite */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "40px" }}>
                <div style={{ textAlign: "left" }}>
                    <p style={{ margin: "0 0 3px 0", fontSize: "12pt", fontWeight: "700" }}>
                        {props?.expertise?.beneficiaire?.personne?.civilite || 'Monsieur'} {props?.expertise?.beneficiaire?.personne?.prenom || ''} {props?.expertise?.beneficiaire?.personne?.nom || 'Victime'}
                    </p>
                    <p style={{ margin: "0 0 3px 0", fontSize: "12pt", fontWeight: "400" }}>
                        <span style={{ fontWeight: "700" }}>Tél:</span> {props?.expertise?.beneficiaire?.personne?.contact?.[0] || ''}
                    </p>
                    <p style={{ margin: "0 0 3px 0", fontSize: "12pt", fontWeight: "400" }}>
                        Lomé – TOGO
                    </p>
                    <p style={{ margin: "8px 0 0 0", fontSize: "12pt", fontWeight: "400" }}>
                        Lomé, le {today}
                    </p>
                </div>
            </div>

            {/* Objet */}
            <div style={{ marginBottom: "30px", marginTop: "30px" }}>
                <p style={{ margin: 0, fontSize: "12pt", fontWeight: "400" }}>
                    <span style={{ fontSize: "11pt", textDecoration: "underline", fontWeight: "700" }}>Objet:</span>{' '}
                    <span style={{ fontSize: "11pt", fontWeight: "700" }}>
                        SIN N° {props?.sinistre?.numSinistre || ''} {props?.sinistre?.contrat?.souscripteur?.nom || ''} C/ {props?.expertise?.beneficiaire?.personne?.nom || ''}
                    </span>
                </p>
                <p style={{ margin: "5px 0 0 60px", fontSize: "12pt", fontWeight: "400" }}>
                    <span style={{ fontSize: "11pt", fontWeight: "700" }}>
                        Accident du {props?.sinistre?.dateDeclaration ? new Date(props.sinistre.dateDeclaration).toLocaleDateString('fr-FR') : ''}
                    </span>
                </p>
            </div>

            {/* Corps du texte */}
            <div style={{ textAlign: "justify", fontSize: "12pt", lineHeight: 1.5, fontWeight: "400" }}>
                <p style={{ marginBottom: "15px" }}>
                    {props?.expertise?.beneficiaire?.personne?.civilite || 'Monsieur'},
                </p>

                <p style={{ marginBottom: "15px" }}>
                    Nous nous référons à l'affaire visée en marge et vous informons que nous sommes disposés à régler cette affaire à l'amiable.
                </p>

                <p style={{ marginBottom: "15px" }}>
                    A cet effet, nous vous prions de bien vouloir vous diriger vers le médecin expert, muni de votre dossier médical relatif à l'accident à savoir : le certificat médical initial, les ordonnances, les radiographies ... ainsi que de votre pièce d'identité, pour une expertise médicale à l'adresse suivante :
                </p>

                {/* Bloc d'adresse de l'expert centré et en gras */}
                <div style={{ textAlign: "center", margin: "20px 0", fontSize: "12pt", fontWeight: "700" }}>
                    <p style={{ margin: "0 0 3px 0" }}>
                        {props?.expertise?.expert?.civilite || 'Docteur'} {props?.expertise?.expert?.nom || ''}
                    </p>
                    <p style={{ margin: "0 0 3px 0" }}>
                        {props?.expertise?.expert?.adresse || 'CLINIQUE'}
                    </p>
                    <p style={{ margin: "0 0 3px 0" }}>
                        Tél : +228 {props?.expertise?.expert?.contact?.[0] || ''}
                    </p>
                    <p style={{ margin: "0 0 3px 0" }}>
                        Lomé – Togo
                    </p>
                </div>

                <p style={{ marginBottom: "15px" }}>
                    Nous vous invitons à prendre un rendez-vous avec le médecin avant d'y aller.
                </p>

                <p style={{ marginBottom: "15px" }}>
                    Par ailleurs, nous vous informons que conformément aux dispositions de l'article 244 du code CIMA, la victime peut au cours de l'expertise se faire assister à ses frais, d'un médecin de son choix.
                </p>

                <p style={{ marginBottom: "15px" }}>
                    Dès réception du rapport d'expertise, nous ne manquerons pas de revenir vers vous.
                </p>

                <p style={{ marginBottom: "15px" }}>
                    Veuillez agréer <span style={{ fontWeight: "700" }}>{props?.expertise?.beneficiaire?.personne?.civilite || 'Monsieur'}</span>, nos salutations distinguées.
                </p>
            </div>

            {/* Signature */}
            <div style={{ marginTop: "60px", textAlign: "center" }}>
                <p style={{ margin: "0", fontSize: "11pt", fontWeight: "700", textDecoration: "underline" }}>
                    {props?.signataire?.nom || 'Koffi G. WARBUTIN'}
                </p>
                <p style={{ margin: "3px 0 0 0", fontSize: "11pt", fontWeight: "400" }}>
                    {props?.signataire?.fonction || 'Directeur'}
                </p>
            </div>

            {/* Espace flexible : pousse le pied en bas (et complète le centrage sur papier à en-tête). */}
            <div style={{ flex: 1 }} />

            {afficherEnteteEtPied && <DocumentFooter />}
        </div>
    )
})

NoteVictime.propTypes = {
    expertise: PropTypes.object,
    sinistre: PropTypes.object,
    signataire: PropTypes.object,
    /** false → imprimé sans en-tête ni pied (papier à en-tête), corps centré. */
    afficherEnteteEtPied: PropTypes.bool
}

export default NoteVictime